import { Controller } from '@hotwired/stimulus'

// One instance per speed/consumption row (span.position-relative). Uses only targets, no querySelector.
export default class extends Controller {
  static targets = ['input', 'default', 'eraseButton']

  connect() {
    this.updateVisibility()
    if (this.hasEraseButtonTarget) {
      this.eraseButtonTarget.addEventListener('click', () => this.restoreDefault())
    }
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener('change', () => this.updateVisibility())
      this.inputTarget.addEventListener('input', () => this.updateVisibility())
    }
  }

  restoreDefault() {
    if (!this.hasDefaultTarget) return
    this.inputTarget.value = this.defaultTarget.value
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  updateVisibility() {
    if (!this.hasInputTarget || !this.hasEraseButtonTarget) return
    const defaultValue = this.hasDefaultTarget ? this.defaultTarget.value : ''
    const currentValue = this.inputTarget.value
    const isCustom = defaultValue !== '' && defaultValue !== undefined && currentValue !== defaultValue
    if (isCustom) {
      this.inputTarget.classList.add('custom-speed-cons')
      this.eraseButtonTarget.style.display = ''
    } else {
      this.inputTarget.classList.remove('custom-speed-cons')
      this.eraseButtonTarget.style.display = 'none'
    }
  }
}
